

  export default {
    props: {
      header: {
        type: String,
        default: ''
      }
    }
  };
